import { render } from "./SidebarVal.vue?vue&type=template&id=3d081b0c&scoped=true"
import script from "./SidebarVal.vue?vue&type=script&lang=js"
export * from "./SidebarVal.vue?vue&type=script&lang=js"

import "./SidebarVal.vue?vue&type=style&index=0&id=3d081b0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d081b0c"]])

export default __exports__